<template>
  <router-view v-if="space"
               :space="space"
               @updated="fetchData">
  </router-view>
</template>

<script>
import spaceService from '../../services/spaceService';
import formValidation from '../../plugins/formValidation';

export default {
  mixins: [formValidation],
  data() {
    return {
      busy: false,
      space: null,
    }
  },
  computed: {
    spaceID() {
      return parseInt(this.$route.params.spaceID);
    }
  },
  created() {
    this.fetchData(this.spaceID);
  },
  methods: {
    fetchData(spaceID) {
      if (!spaceID) {
        spaceID = this.spaceID;
      }
      this.busy = true;
      spaceService.getSpace(spaceID)
        .then(space => {
          this.space = space;
        })
        .catch(err => {
          this.$router.replace({name: 'admin.spaces.index'});
        })
        .finally(() => {
          this.busy = false;
        })
    },
  }
}
</script>
